module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-SemiBoldItalic-e44a3d59985443abe8d743ef9ee934c3.woff";